module.exports = __webpack_public_path__ + "static/media/locknox-logo.76a5a481.jpg";